/**

 * CodeSkin wishlist — localStorage, header badge, product card hearts, full page UI.

 */

(function () {

  var STORAGE_KEY = 'codeskin-wishlist-v1';

  var WISHLIST_IMAGE_RULES = [
    {
      test: function (h) {
        return h.indexOf('ultraprotect') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/UltraProtect_Fluid_SPF100__02.png?v=1785387057',
    },
    {
      test: function (h) {
        return h.indexOf('ultralite') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/UltraLite_Fluid_SPF50__02.png?v=1792992385',
    },
    {
      test: function (h) {
        return h.indexOf('ultramineral') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/UltraMineral_Glo_SPF40__02.png?v=1792991541',
    },
    {
      test: function (h) {
        return h.indexOf('mineral-gel') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/UltraMatte_Mineral_Gel_SPF50__02.png?v=1785493010',
    },
    {
      // 'ultramatte-oil-free' alone also matches the fluid sunscreen's handle
      // (…-oil-free-sunscreen-spf-50 / …-oil-free-liquid-sunscreen), so require
      // 'moisturizer' too before assuming it's the moisturizer.
      test: function (h) {
        return (
          h.indexOf('ultramatte-moisturizer') !== -1 ||
          h.indexOf('oil-free-moisturizer') !== -1 ||
          (h.indexOf('ultramatte-oil-free') !== -1 && h.indexOf('moisturizer') !== -1)
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/UltraMatte_Moisturizer__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return h.indexOf('ultramatte') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/UltraMatte_OilFree_Fluid_SPF50__02.png?v=1785493010',
    },
    {
      test: function (h) {
        return h.indexOf('ultrasensitive') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/UltraSensitive_Mineral_SPF50__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return h.indexOf('sunstick') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/SunStick_SPF50__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return h.indexOf('tribio') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/Tribio_Retinol__02.png?v=1785493010',
    },
    {
      test: function (h) {
        return h.indexOf('retinol-glo') !== -1 || h.indexOf('glo-cream') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/Retinol_GLO_Cream__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return (
          h.indexOf('ac-spot') !== -1 ||
          h.indexOf('clarifi-spot') !== -1 ||
          h.indexOf('clarifi-ac-spot') !== -1 ||
          h.indexOf('spot-corrector') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/CLARIFI_AC_Spot__02.png?v=1785493008',
    },
    {
      test: function (h) {
        return h.indexOf('clarifi-ac-serum') !== -1 || h.indexOf('acne-control') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/CLARIFI_AC_Serum__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return (
          h.indexOf('pore-minimizer') !== -1 ||
          h.indexOf('poreminimizer') !== -1 ||
          h.indexOf('pore-serum') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/PoreMinimizer_Serum__02.png?v=1785493010',
    },
    {
      test: function (h) {
        return (
          h.indexOf('oilcontrol') !== -1 ||
          h.indexOf('oil-control') !== -1 ||
          h.indexOf('radiance-serum') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/OilControl_Radiance_Serum__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return h.indexOf('hyaluronic') !== -1 || h.indexOf('ha-7') !== -1 || h.indexOf('ha7') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/Hyaluronic_7_Serum__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return (
          h.indexOf('gold-vitamin-c') !== -1 ||
          h.indexOf('goldvitac') !== -1 ||
          h.indexOf('gold-vita-c') !== -1 ||
          h.indexOf('gold-vitac') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/GoldVitaC__02.png?v=1785493010',
    },
    {
      test: function (h) {
        return (
          h.indexOf('darkspot-correcting') !== -1 ||
          h.indexOf('dark-spot-correcting') !== -1 ||
          h.indexOf('darkspot') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/DarkSpot_Correcting_Day_Serum__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return h.indexOf('clarifi-skar') !== -1 || h.indexOf('skar-serum') !== -1 || h.indexOf('skar') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/CLARIFI_Skar_Serum__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return h.indexOf('sensi-ac') !== -1 || h.indexOf('clarifi-sensi') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/CLARIFI_Sensi_AC_Serum__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return (
          h.indexOf('clarifi-bc') !== -1 ||
          h === 'clarifi-bc-acne-marks-serum' ||
          h.indexOf('bc-serum') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/CLARIFI_BC_Serum__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return (
          h.indexOf('ultraclarifi-acne-moisturizer') !== -1 ||
          h.indexOf('ultraclarifi-moisturizer') !== -1 ||
          h.indexOf('ultraclarifi') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/UltraClarifi_Moisturizer__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return h.indexOf('ultraintense') !== -1 || h.indexOf('intense-moisturizer') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/UltraIntense_Moisturizer__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return (
          h.indexOf('barrier-dfense') !== -1 ||
          h.indexOf('barrier-defense') !== -1 ||
          h.indexOf('barrier') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/Barrier_Dfense_Lotion__02_f5eb0700-417b-4861-b99f-aed05367566b.png?v=1787911869',
    },
    {
      test: function (h) {
        return (
          h.indexOf('facewash-sensi') !== -1 ||
          h.indexOf('sensi-facewash') !== -1 ||
          h.indexOf('sensi-wash') !== -1 ||
          h.indexOf('facewashsensi') !== -1 ||
          h.indexOf('sensi-cleanser') !== -1 ||
          h.indexOf('sensitive-skin-face-wash') !== -1 ||
          h.indexOf('facewash-sensi') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/FaceWash_SENSI__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return (
          h.indexOf('facewash-oily') !== -1 ||
          h.indexOf('oily-facewash') !== -1 ||
          h.indexOf('oily-wash') !== -1 ||
          h.indexOf('facewashoily') !== -1 ||
          h.indexOf('oily-cleanser') !== -1 ||
          h.indexOf('oily-skin-face-wash') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/FaceWash_OILY__02.png?v=1785493010',
    },
    {
      test: function (h) {
        return (
          h.indexOf('facewash-clarifi') !== -1 ||
          h.indexOf('clarifi-facewash') !== -1 ||
          h.indexOf('clarifi-wash') !== -1 ||
          h.indexOf('facewashclarifi') !== -1 ||
          h.indexOf('clarifi-cleanser') !== -1 ||
          h.indexOf('clarifi-anti-acne') !== -1 ||
          h.indexOf('anti-acne-face-wash') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/FaceWash_CLARIFI__02.png?v=1785493010',
    },
    {
      test: function (h) {
        return (
          h.indexOf('facewash-brite') !== -1 ||
          h.indexOf('brite-facewash') !== -1 ||
          h.indexOf('brite-wash') !== -1 ||
          h.indexOf('facewashbrite') !== -1 ||
          h.indexOf('brite-cleanser') !== -1 ||
          h.indexOf('brightening-face-wash') !== -1 ||
          h.indexOf('brite') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/FaceWash_BRITE__02.png?v=1785493010',
    },
    {
      test: function (h) {
        return (
          h.indexOf('velvet-foot-cream') !== -1 ||
          h.indexOf('foot-cream') !== -1 ||
          h.indexOf('velvet-foot') !== -1 ||
          h.indexOf('velvetfoot') !== -1 ||
          h.indexOf('footcream') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/Velvet_Foot_Cream__02.png?v=1785505446',
    },
    {
      test: function (h) {
        return h.indexOf('double-depth') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/Double_Depth_Cleansing_Oil__02.png?v=1785732645',
    },
    {
      test: function (h) {
        return h.indexOf('brightening-micellar') !== -1 || h.indexOf('micellar-water') !== -1;
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/Brightening_Micellar_Water__02.png?v=1785493009',
    },
    {
      test: function (h) {
        return (
          h.indexOf('ultraadvance') !== -1 ||
          h.indexOf('body-moisturizer') !== -1 ||
          h.indexOf('ultra-advance') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/UltraAdvance_BodyMoisturizer__02.png?v=1785493008',
    },
    {
      test: function (h) {
        return (
          h.indexOf('vitafirm') !== -1 ||
          h.indexOf('firming-gel') !== -1 ||
          h.indexOf('vita-firm') !== -1
        );
      },
      url: 'https://cdn.shopify.com/s/files/1/0649/1403/0635/files/VitaFirm_Gel__02.png?v=1786338409',
    },
  ];

  function resolveWishlistImage(handle, fallback) {
    var h = String(handle || '').toLowerCase();
    if (!h) return fallback || '';

    for (var i = 0; i < WISHLIST_IMAGE_RULES.length; i += 1) {
      if (WISHLIST_IMAGE_RULES[i].test(h)) {
        return WISHLIST_IMAGE_RULES[i].url;
      }
    }

    return fallback || '';
  }



  function getWishlist() {

    try {

      var raw = localStorage.getItem(STORAGE_KEY);

      var parsed = raw ? JSON.parse(raw) : [];

      return Array.isArray(parsed) ? parsed : [];

    } catch (e) {

      return [];

    }

  }



  function saveWishlist(list) {

    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));

    document.dispatchEvent(

      new CustomEvent('codeskin:wishlist-updated', {

        detail: { list: list },

      })

    );

  }



  function isSaved(productId) {

    return getWishlist().some(function (item) {

      return String(item.id) === String(productId);

    });

  }



  function toggleWishlist(productId, productHandle, productTitle, productImage, productPrice) {

    var list = getWishlist();

    var idx = list.findIndex(function (item) {

      return String(item.id) === String(productId);

    });

    if (idx > -1) {

      list.splice(idx, 1);

      saveWishlist(list);

      return false;

    }

    list.push({

      id: String(productId),

      handle: productHandle || '',

      title: productTitle || '',

      image: resolveWishlistImage(productHandle, productImage),

      price: productPrice || '',

    });

    saveWishlist(list);

    return true;

  }



  function syncButton(btn) {

    if (!btn) return;

    var id = btn.getAttribute('data-product-id');

    var active = isSaved(id);

    btn.classList.toggle('is-active', active);

    btn.setAttribute('aria-pressed', active ? 'true' : 'false');

    btn.setAttribute(

      'aria-label',

      active ? 'Remove from wishlist' : 'Add to wishlist'

    );

  }



  function syncProductWishlistButtons(productId) {

    document

      .querySelectorAll('[data-codeskin-wishlist][data-product-id="' + productId + '"]')

      .forEach(syncButton);

  }



  function showToast(message, type) {

    if (typeof window.showCodeskinCartToast === 'function') {

      window.showCodeskinCartToast(message, type || 'success');

      return;

    }



    var existing = document.querySelector('.codeskin-cart-toast');

    if (existing) existing.remove();



    var toast = document.createElement('div');

    toast.className = 'codeskin-cart-toast codeskin-cart-toast--' + (type || 'success');

    toast.setAttribute('role', 'status');

    toast.setAttribute('aria-live', 'polite');

    toast.innerHTML =

      '<span class="codeskin-cart-toast__icon" aria-hidden="true">' +

      (type === 'error' ? '!' : '✓') +

      '</span><span class="codeskin-cart-toast__text"></span>';

    toast.querySelector('.codeskin-cart-toast__text').textContent = message;

    document.body.appendChild(toast);

    requestAnimationFrame(function () {

      toast.classList.add('is-visible');

    });

    window.setTimeout(function () {

      toast.classList.remove('is-visible');

      window.setTimeout(function () {

        toast.remove();

      }, 320);

    }, 3400);

  }



  function updateHeaderBadge() {

    var count = getWishlist().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(function (badge) {

      if (count <= 0) {

        badge.classList.add('hidden');

        badge.textContent = '';

      } else {

        badge.classList.remove('hidden');

        badge.textContent = count > 99 ? '99+' : String(count);

      }

    });

  }

  function getWishlistPageUrl() {
    var headerLink = document.getElementById('codeskin-wishlist-icon');
    if (headerLink && headerLink.getAttribute('href')) {
      return headerLink.getAttribute('href');
    }
    return '/pages/wishlist';
  }

  function openWishlistPage() {
    var url = getWishlistPageUrl();
    if (!url || url.charAt(0) === '#') return;
    var currentPath = (window.location.pathname || '').replace(/\/+$/, '');
    var targetPath = url.replace(window.location.origin, '').replace(/\/+$/, '');
    if (targetPath && currentPath === targetPath) return;
    window.location.href = url;
  }



  function escapeHtml(str) {

    return String(str || '')

      .replace(/&/g, '&amp;')

      .replace(/</g, '&lt;')

      .replace(/>/g, '&gt;')

      .replace(/"/g, '&quot;');

  }



  function buildCardHtml(item) {

    var url = item.handle ? '/products/' + encodeURIComponent(item.handle) : '#';

    var title = escapeHtml(item.title || 'Product');

    var priceHtml = item.price
      ? '<div class="product-price heading-font">' + escapeHtml(item.price) + '</div>'
      : '';

    var imageBlock = item.image

      ? '<img src="' +

        escapeHtml(item.image) +

        '" alt="" class="product--card-image" width="400" height="400" loading="lazy" decoding="async">'

      : '<span class="codeskin-wl-card__placeholder">No image</span>';



    return (

      '<div class="product--card">' +

      '<article class="product--card-inner codeskin-product-card codeskin-wl-card" data-codeskin-wl-item data-product-id="' +

      escapeHtml(item.id) +

      '">' +

      '<div class="product--card-image width-100 pos-relative">' +

      '<a href="' +

      url +

      '" class="product--image d-block width-100" aria-label="' +

      title +

      '">' +

      '<div class="media" style="--image_ratio:100%">' +

      imageBlock +

      '</div>' +

      '</a>' +

      '<button type="button" class="codeskin-wl-card__remove" data-codeskin-wishlist-remove data-product-id="' +

      escapeHtml(item.id) +

      '" aria-label="Remove ' +

      title +

      ' from wishlist">' +

      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +

      '</button>' +

      '</div>' +

      '<div class="product--card-detail">' +

      '<div class="product--card-detail-inner">' +

      '<div class="product--card-detail-content">' +

      '<a href="' +

      url +

      '" class="product--title">' +

      title +

      '</a>' +

      '<div class="product-card-atc-wrapper codeskin-collection-atc-form">' +

      '<div class="product-price-row">' +

      priceHtml +

      '<div class="codeskin-card-cart-actions">' +

      '<button type="button" class="product-card-cart-btn codeskin-card-add-btn" data-codeskin-wishlist-atc data-codeskin-atc-variant="' +

      escapeHtml(item.variantId || '') +

      '" data-variant-id="' +

      escapeHtml(item.variantId || '') +

      '" data-product-handle="' +

      escapeHtml(item.handle || '') +

      '" data-product-title="' +

      escapeHtml(item.title || '') +

      '"' +

      (item.available === false ? ' disabled' : '') +

      '>Add</button>' +

      '<div class="codeskin-card-qty" data-codeskin-card-qty hidden aria-label="Quantity in cart">' +

      '<button type="button" class="codeskin-card-qty-btn" data-codeskin-qty-minus aria-label="Remove one from cart">' + String.fromCharCode(8722) + '</button>' +

      '<span class="codeskin-card-qty-value" data-codeskin-qty-value aria-live="polite">1</span>' +

      '<button type="button" class="codeskin-card-qty-btn" data-codeskin-qty-plus aria-label="Add one more to cart">+</button>' +

      '</div>' +

      '</div>' +

      '</div>' +

      '</div>' +

      '</div>' +

      '</div>' +

      '</div>' +

      '</article>' +

      '</div>'

    );

  }



  function bindWishlistAddButtons(scope) {
    (scope || document).querySelectorAll('[data-codeskin-wishlist-atc]').forEach(function (btn) {
      if (btn.dataset.wishlistAtcBound === 'true') return;
      btn.dataset.wishlistAtcBound = 'true';

      btn.addEventListener('click', function (event) {
        if (btn.disabled) return;
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        var variantId = btn.getAttribute('data-variant-id');
        var handle = btn.getAttribute('data-product-handle') || '';
        var title = btn.getAttribute('data-product-title') || '';

        if (window.codeskinCart && typeof window.codeskinCart.guardCartPageNavigation === 'function') {
          window.codeskinCart.guardCartPageNavigation(1400);
        }

        function runAdd(id) {
          if (!id) {
            showToast('Could not add to bag', 'error');
            return;
          }
          if (window.codeskinCart && typeof window.codeskinCart.addVariant === 'function') {
            window.codeskinCart.addVariant(id, 1);
            return;
          }
          showToast('Could not add to bag', 'error');
        }

        if (variantId) {
          runAdd(variantId);
          return;
        }

        if (!handle) {
          showToast('Could not add to bag', 'error');
          return;
        }

        btn.disabled = true;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .then(function (product) {
            var variant = pickVariant(product);
            if (variant) {
              btn.setAttribute('data-variant-id', String(variant.id));
              btn.setAttribute('data-codeskin-atc-variant', String(variant.id));
              runAdd(String(variant.id));
            } else {
              showToast('Could not add to bag', 'error');
            }
          })
          .catch(function () {
            showToast('Could not add to bag', 'error');
          })
          .finally(function () {
            btn.disabled = false;
          });
      });
    });
  }

  function bindRemoveButtons(scope) {

    (scope || document).querySelectorAll('[data-codeskin-wishlist-remove]').forEach(function (btn) {

      if (btn.dataset.wishlistRemoveBound === 'true') return;

      btn.dataset.wishlistRemoveBound = 'true';

      btn.addEventListener('click', function (event) {

        event.preventDefault();

        event.stopPropagation();

        var id = btn.getAttribute('data-product-id');

        var listNow = getWishlist();

        var item = listNow.find(function (i) {

          return String(i.id) === String(id);

        });

        toggleWishlist(id, item ? item.handle : '', item ? item.title : '', '', '');

        syncProductWishlistButtons(id);

        updateHeaderBadge();

        renderWishlistPage();

        showToast('Removed from wishlist', 'success');

      });

    });

  }



  function pickVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0];
  }

  function fetchProductMeta(item) {
    var next = Object.assign({}, item);
    next.image = resolveWishlistImage(next.handle, next.image);

    if (!next.handle) {
      return Promise.resolve(next);
    }

    if (next.price && next.variantId) {
      return Promise.resolve(next);
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return fetch(root + 'products/' + encodeURIComponent(next.handle) + '.js', {
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        if (!product) return next;

        var variant = pickVariant(product);

        next.image = resolveWishlistImage(
          next.handle,
          product.featured_image || next.image
        );

        if (variant) {
          if (!next.variantId) next.variantId = String(variant.id);
          if (!next.price) {
            var cents = variant.price;
            if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
              next.price = window.Shopify.formatMoney(cents);
            } else if (cents) {
              next.price = '₹' + (cents / 100).toFixed(0);
            }
          }
          next.available = !!variant.available;
        }

        if (!next.title && product.title) next.title = product.title;

        return next;
      })

      .catch(function () {

        return next;

      });

  }



  function enrichWishlist(list) {

    return Promise.all(list.map(fetchProductMeta)).then(function (enriched) {

      var stored = getWishlist();

      var changed = false;

      enriched.forEach(function (item, i) {

        if (!stored[i]) return;

        if (item.image && item.image !== stored[i].image) {

          stored[i].image = item.image;

          changed = true;

        }

        if (item.price && item.price !== stored[i].price) {

          stored[i].price = item.price;

          changed = true;

        }

        if (item.title && item.title !== stored[i].title) {
          stored[i].title = item.title;
          changed = true;
        }

        if (item.variantId && item.variantId !== stored[i].variantId) {
          stored[i].variantId = item.variantId;
          changed = true;
        }
      });

      if (changed) saveWishlist(stored);

      return enriched;

    });

  }



  function setWishlistLoading(page, show) {
    if (!page) return;
    var loading = page.querySelector('[data-codeskin-wishlist-page-loading]');
    var grid = page.querySelector('[data-codeskin-wishlist-page-grid]');
    if (loading) {
      if (show) {
        loading.removeAttribute('hidden');
      } else {
        loading.setAttribute('hidden', '');
      }
    }
    if (grid) {
      grid.classList.toggle('is-loading', !!show);
    }
  }

  function formatWishlistTotal(total) {
    if (total <= 1) return '1 saved product';
    return total + ' saved products';
  }

  function getWishlistScrollStep(grid) {
    var card = grid.querySelector('.product--card');
    if (!card) return Math.max(120, grid.clientWidth * 0.75);
    var style = window.getComputedStyle(grid);
    var gap = parseFloat(style.columnGap || style.gap) || 10;
    return card.offsetWidth + gap;
  }

  function getWishlistVisibleRange(grid) {
    var cards = grid.querySelectorAll('.product--card');
    if (!cards.length) return { start: 0, end: 0 };
    var gridRect = grid.getBoundingClientRect();
    var start = 0;
    var end = 0;
    for (var i = 0; i < cards.length; i += 1) {
      var rect = cards[i].getBoundingClientRect();
      if (rect.right > gridRect.left + 4 && rect.left < gridRect.right - 4) {
        if (!start) start = i + 1;
        end = i + 1;
      }
    }
    if (!start) start = 1;
    if (!end) end = cards.length;
    return { start: start, end: end };
  }

  function syncWishlistScrollNav(page) {
    if (!page) return;
    var grid = page.querySelector('[data-codeskin-wishlist-page-grid]');
    var status = page.querySelector('[data-codeskin-wishlist-page-pagination]');
    var carousel = page.querySelector('[data-codeskin-wishlist-carousel]');
    if (!grid || !status) return;

    var total = grid.querySelectorAll('.product--card').length;
    var prev = page.querySelector('[data-codeskin-wishlist-scroll-prev]');
    var next = page.querySelector('[data-codeskin-wishlist-scroll-next]');

    if (!total) {
      status.hidden = true;
      status.textContent = '';
      if (carousel) carousel.hidden = true;
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    if (carousel) carousel.hidden = false;
    status.hidden = false;

    var maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
    var canScroll = maxScroll > 4;
    var useSideArrows = canScroll && window.matchMedia('(max-width: 900px)').matches;

    if (prev) {
      prev.hidden = !useSideArrows;
      prev.disabled = grid.scrollLeft <= 4;
    }
    if (next) {
      next.hidden = !useSideArrows;
      next.disabled = grid.scrollLeft >= maxScroll - 4;
    }

    if (canScroll) {
      var range = getWishlistVisibleRange(grid);
      status.textContent =
        range.start === range.end
          ? range.start + ' of ' + total + ' saved products'
          : range.start + '–' + range.end + ' of ' + total + ' saved products';
    } else {
      status.textContent = formatWishlistTotal(total);
    }
  }

  function scrollWishlistGrid(grid, direction) {
    if (!grid) return;
    grid.scrollBy({
      left: direction * getWishlistScrollStep(grid),
      behavior: 'smooth',
    });
  }

  function bindWishlistScrollNav(page) {
    if (!page || page.dataset.wishlistScrollBound === 'true') return;
    page.dataset.wishlistScrollBound = 'true';

    var grid = page.querySelector('[data-codeskin-wishlist-page-grid]');
    if (!grid) return;

    page.addEventListener('click', function (event) {
      var target = event.target.closest(
        '[data-codeskin-wishlist-scroll-prev],[data-codeskin-wishlist-scroll-next]'
      );
      if (!target || target.disabled || target.hidden) return;

      if (target.hasAttribute('data-codeskin-wishlist-scroll-prev')) {
        scrollWishlistGrid(grid, -1);
      } else {
        scrollWishlistGrid(grid, 1);
      }
    });

    grid.addEventListener(
      'scroll',
      function () {
        syncWishlistScrollNav(page);
      },
      { passive: true }
    );
  }

  function renderWishlistScrollNav(page, total) {
    if (!page) return;

    if (!page.dataset.wishlistScrollBound) {
      bindWishlistScrollNav(page);
    }

    syncWishlistScrollNav(page);
  }

  function renderWishlistPage() {
    var page = document.querySelector('[data-codeskin-wishlist-page]');
    if (!page) return;

    var grid = page.querySelector('[data-codeskin-wishlist-page-grid]');
    var empty = page.querySelector('[data-codeskin-wishlist-page-empty]');
    var countEl = page.querySelector('[data-codeskin-wishlist-page-count]');
    if (!grid) return;

    var list = getWishlist();

    if (countEl) {
      if (list.length) {
        countEl.hidden = false;
        countEl.textContent = formatWishlistTotal(list.length);
      } else {
        countEl.hidden = true;
        countEl.textContent = '';
      }
    }

    if (!list.length) {
      grid.innerHTML = '';
      setWishlistLoading(page, false);
      renderWishlistScrollNav(page, 0);
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    setWishlistLoading(page, true);
    grid.innerHTML = '';

    enrichWishlist(list)
      .then(function (enriched) {
        var activePage = document.querySelector('[data-codeskin-wishlist-page]');
        var activeGrid =
          activePage && activePage.querySelector('[data-codeskin-wishlist-page-grid]');
        if (!activeGrid) return;

        activeGrid.innerHTML = enriched.map(buildCardHtml).join('');
        bindRemoveButtons(activeGrid);
        bindWishlistAddButtons(activeGrid);
        if (window.codeskinCart && typeof window.codeskinCart.syncAddedFromCart === 'function') {
          window.codeskinCart.syncAddedFromCart();
        }
        renderWishlistScrollNav(activePage, enriched.length);
        requestAnimationFrame(function () {
          syncWishlistScrollNav(activePage);
        });
        setWishlistLoading(activePage, false);
      })
      .catch(function () {
        var activePage = document.querySelector('[data-codeskin-wishlist-page]');
        setWishlistLoading(activePage, false);
        if (empty) empty.hidden = false;
      });
  }



  function initHeaderWishlist() {
    updateHeaderBadge();
  }



  window.initCodeskinWishlist = function (root) {

    var scope = root || document;

    scope.querySelectorAll('[data-codeskin-wishlist]').forEach(function (btn) {

      if (btn.dataset.wishlistBound === 'true') return;

      btn.dataset.wishlistBound = 'true';

      syncButton(btn);



      btn.addEventListener('click', function (event) {

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();



        var id = btn.getAttribute('data-product-id');

        var handle = btn.getAttribute('data-product-handle') || '';

        var title = btn.getAttribute('data-product-title') || '';

        var image = resolveWishlistImage(
          btn.getAttribute('data-product-handle') || '',
          btn.getAttribute('data-product-image') || ''
        );

        var price = btn.getAttribute('data-product-price') || '';

        var added = toggleWishlist(id, handle, title, image, price);

        syncProductWishlistButtons(id);

        updateHeaderBadge();

        renderWishlistPage();



        if (added) {
          showToast((title ? title + ' - ' : '') + 'Saved to wishlist', 'success');
        } else {
          showToast('Removed from wishlist', 'success');
        }

      });

    });

  };



  function boot() {

    initHeaderWishlist();

    window.initCodeskinWishlist(document);

    renderWishlistPage();

  }



  document.addEventListener('codeskin:wishlist-updated', function () {

    updateHeaderBadge();

    renderWishlistPage();

  });

  window.addEventListener('resize', function () {
    var page = document.querySelector('[data-codeskin-wishlist-page]');
    if (!page) return;
    syncWishlistScrollNav(page);
  });



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', boot);

  } else {

    boot();

  }

})();


